import { Text } from '@kanda-libs/ks-design-library';

import { BriefcaseBusiness } from 'lucide-react';

import PrimaryEmployment from './PrimaryEmployment';
import SecondaryEmployment from './SecondaryEmployment';

import { YOUR_INFO_CLASS_NAMES } from '../constants';

const EmploymentInformationFields: React.FunctionComponent = function () {
  return (
    <>
      <div className="flex flex-col">
        <div className="flex flex-row gap-x-3 items-center">
          <BriefcaseBusiness size={20} />
          <Text className={YOUR_INFO_CLASS_NAMES.title} text="Employment" />
        </div>
      </div>
      <PrimaryEmployment />
      <SecondaryEmployment />
    </>
  );
};

export default EmploymentInformationFields;
